// ModifyOrderModal.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Post } from "../services/api";

const ModifyOrderModal = (props) => {
  const [price, set_price] = useState("");
  const [quantity, set_quantity] = useState("");
  const [type, set_type] = useState("");

  const [trade_id, set_trade_id] = useState("");

  const [loader, set_loader] = useState(false);

  const [pair, set_pair] = useState();

  // Sync with props on open
  useEffect(() => {
    if (props.EditModel) {
      set_price(props.price);
      set_quantity(props.quantity);
      set_type(props.type);
      set_trade_id(props.trade_id);
      set_pair(props.pair);
    }
    console.log("Modal opened and props synced");
  }, [
    props.EditModel,
    props.price,
    props.quantity,
    props.type,
    props.trade_id,
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (price <= 0) {
      toast.error("Please Enter a Valid Price");
      return;
    }

    if (quantity <= 0) {
      toast.error("Please Enter a Valid Amount");
      return;
    }

    const payload = {
      pair: pair, // make sure this matches backend expected format
      price: Number(price),
      quantity: Number(quantity),
      order_id: String(trade_id), // backend expects string for order_id
    };

    set_loader(true);

    console.log("order update call ornot");

    console.log(props.socket);

    set_loader(true);
    // Emit the socket event instead of HTTP POST
    props.socket.emit("update_order", payload, (response) => {
      if (response?.status) {
        toast.success(response.message);
        props.refreshPage();
        props.closeModel();
        set_loader(false)
      } else {
        set_loader(false);
        toast.error(response?.message || "Order update failed");
      }
    });
  };

  const handlePriceChange = (event) => {
    let value = event.target.value;

    console.log(value);
    // Prevent negative values
    if (parseFloat(value) < 0 || isNaN(value)) {
      return; // Do nothing if it's a negative value
    }

    // Allow only 8 digits before the decimal and 8 digits after the decimal

    set_price(value);
  };
  const handleQuantityChange = (event) => {
    let value = event.target.value;
    // Prevent negative values

    // Prevent negative values (optional, depending on your requirements)
    if (parseFloat(value) < 0 || isNaN(value)) {
      return; // Do nothing if it's a negative value
    }
    console.log(value);
    // Allow only 8 digits before the decimal and 8 digits after the decimal
    set_quantity(value);
  };

  return (
    <Modal
      className="modify_order"
      show={props.EditModel}
      onHide={!loader ? props.closeModel : undefined}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Modify {type} Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label htmlFor="price_input" className="form-label">
          Price
        </label>
        <input
          type="text"
          step="any"
          id="price_input"
          value={price}
          onChange={handlePriceChange}
          name="buyPrice"
          className="form-control mb-3"
        />

        <label htmlFor="quantity_input" className="form-label">
          Amount
        </label>
        <input
          type="text"
          step="any"
          id="quantity_input"
          value={quantity}
          onChange={handleQuantityChange}
          name="buyQuantity"
          className="form-control mb-3"
        />
        <button
          onClick={handleSubmit}
          disabled={loader}
          className={`btn w-100 ${
            type === "Sell" ? "my_color_sell" : "my_color_buy"
          }`}
        >
          Update
        </button>
      </Modal.Body>
    </Modal>
  );
};

export { ModifyOrderModal };
